import { render } from "./RopeHistory.vue?vue&type=template&id=cd9220a0&scoped=true"
import script from "./RopeHistory.vue?vue&type=script&lang=js"
export * from "./RopeHistory.vue?vue&type=script&lang=js"

import "./RopeHistory.vue?vue&type=style&index=0&id=cd9220a0&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9220a0"]])

export default __exports__